module.exports = __webpack_public_path__ + "static/media/play-board-5.2b1ae506.png";